import Card from "components/card";
import { useEffect, useState } from "react";
import { Button } from "components/button";
import { MdAdd } from "react-icons/md";
import { adminsStore } from "views/store/useAdminsStore";
import { adminsService } from "views/services/adminsService";
import { AdminItem } from "./components/AdminItem";
import { AdminDialog } from "./components/AdminDialog";

function AdminsView() {
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const { admins } = adminsStore();

  const refreshAdminList = async () => {
    try {
      await adminsService.getAdminsList();
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    refreshAdminList();
  }, []);

  const adminList = admins.filter(admin => admin.role !== 'SUPER_ADMIN')

  const filteredAdmins = adminList.filter(admin => admin.email.toLowerCase().includes(search.trim().toLowerCase()));

  return (
    <>
      <div className="mb-8 mt-8 flex items-center justify-between">
        <div className="flex gap-2 ml-auto">
          <AdminDialog>
            <Button>
              <MdAdd />
              Add admin
            </Button>
          </AdminDialog>
        </div>
      </div>
      <Card extra={"w-full sm:h-[800px] min-h-[300px] md:h-[500px]  sm:overflow-auto px-6 pb-6"}>
        <header className="relative flex items-center justify-between pt-4">
          <div className="text-xl font-bold text-navy-700">
            Admins
          </div>
          <input
            type="text"
            placeholder="Search by email"
            className="block min-h-7 w-full grow rounded-full bg-lightPrimary px-4 text-base font-merow rounded-full bg-lightPrimary px-4 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:h-full sm:w-fit sm:max-w-96"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </header>

        <div className="mt-8 overflow-x-auto xl:overflow-x-hidden flex flex-col gap-2">
          {isLoading ? (
            <span>Loading...</span>
          ) : (
            filteredAdmins.map((admin) => {
              return <AdminItem admin={admin} key={admin.id} />;
            })
          )}
        </div>
      </Card>
    </>
  );
}

export default AdminsView;
